import React from 'react';
import PropTypes from 'prop-types';
import StyledLandingTeaser from './landingTeaser.style';
import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';
import BasicTeaser from '../../molecules/basic-teaser/basicTeaser';
import { LongArrowRight } from '../../icons/arrow/arrow';

const LandingTeaser = ({ teasers = [], headline, linkText, linkTo }) => {
  return (
    <StyledLandingTeaser>
      {headline && (
        <Container large>
          <Headline secondary tag="h3" className="landing-teaser__headline">
            {headline}
          </Headline>
        </Container>
      )}
      <Container>
        <div className="landing-teaser__grid">
          {teasers.map(item => (
            <BasicTeaser
              className="landing-teaser__item"
              size="s"
              key={item.id}
              headline={item.headline}
              subline={item.subline}
              introCopy={item.introCopy}
              image={item.titleImage}
              uri={item.uri}
            />
          ))}
          {linkText && linkTo && (
            <div className="landing-teaser__item landing-teaser__more">
              <a className="landing-teaser__link" href={linkTo}>
                <Headline tag="span">{linkText}</Headline>
                <LongArrowRight />
              </a>
            </div>
          )}
        </div>
      </Container>
    </StyledLandingTeaser>
  );
};

LandingTeaser.propTypes = {
  headline: PropTypes.string,
  linkText: PropTypes.string,
  linkTo: PropTypes.string,
  teasers: PropTypes.arrayOf({
    id: PropTypes.number.isRequired,
    headline: PropTypes.string.isRequired,
    subline: PropTypes.string,
    introCopy: PropTypes.string,
    image: PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string
    })
  })
};

export default LandingTeaser;
